import React, { ReactElement } from 'react';
import styled from 'styled-components/macro';
import RatingComponent from 'react-rating';
import Prompt from './Shared/Prompt';
import QuestionWrapper from './Shared/QuestionWrapper';
import { StarEmpty, StarFull } from 'assets/icons';

interface IRating {
  index: number;
  prompt: string;
  minValue: number;
  maxValue: number;
  isRequired: boolean;
}

const Rating = ({ index, prompt, minValue, maxValue, isRequired }: IRating): ReactElement => {
  return (
    <QuestionWrapper index={index}>
      <Prompt prompt={prompt} isRequired={isRequired} />
      <br />

      <RatingComponent
        start={minValue}
        stop={maxValue}
        emptySymbol={
          <IconContainer>
            <StarEmpty />
          </IconContainer>
        }
        fullSymbol={
          <IconContainer>
            <StarFull />
          </IconContainer>
        }
      />
    </QuestionWrapper>
  );
};

export default Rating;

const IconContainer = styled.div`
  display: flex;
  flex: 1;
  width: 30px;
  height: 30px;
  justify-content: center;
  align-items: center;
`;
